import React from 'react';
import ProductCard from '../components/ProductCard';
import { products } from '../data/products';
import { Gift, ArrowRight } from 'lucide-react';
import { useProducts } from '../context/ProductContext';

const Home = () => {

  const { products, loadingProducts } = useProducts();

  if (loadingProducts) {
    return <div style={{ textAlign: 'center', padding: '5rem' }}>Loading products...</div>;
  }
  return (
    <div className="animate-slide-up">

      {/* Hero Section */}
      <section style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4rem',
        alignItems: 'center',
        marginBottom: '6rem',
        background: 'transparent'
      }}>
        <div style={{ flex: '1 1 400px' }}>
          <h1 className="hero-heading" style={{ marginBottom: '1rem', fontWeight: '700' }}>
            Exclusive handcrafted gifts,<br />delivered fast to your loved ones.
          </h1>
          <p style={{ color: 'var(--text-muted)', marginBottom: '2rem', maxWidth: '500px', fontSize: '13px' }}>
            Discover our premium curated collection of unique memories, decor, and delightful hampers designed to bring joy instantly.
          </p>
          <button className="btn btn-primary" onClick={() => window.scrollTo({ top: 800, behavior: 'smooth' })}>
            Explore Collection <ArrowRight size={14} />
          </button>
        </div>

        <div style={{ flex: '1 1 400px', display: 'flex', justifyContent: 'center', position: 'relative' }}>
          <img
            src="/gift.png"
            alt="Beautiful Gift Collection"
            className="float-animation"
            style={{
              width: '100%',
              maxWidth: '450px',
              height: 'auto',
              background: 'transparent'
            }}
          />
        </div>
      </section>

      {/* Featured Products */}
      <section>
        <div style={{ marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '2rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
            Trending Gifts
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>Top-rated bespoke items chosen by our customers.</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '2rem' }}>
          {products.map((product, index) => (
            <div key={product.id} className={`delay-${(index % 3 + 1) * 100}`}>
              <ProductCard product={product} />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;
